<template>
  <v-container v-if="profile" class="profile">
    <v-row class="my-6">
      <v-col cols="12">
        <div class="display-3 mt-12 text-capitalize">
          {{ profile.alias }}'s Wall
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-expansion-panels popout multiple>
          <v-expansion-panel
            elevation="10"
            class="mb-1"
            v-for="(comment, i) in comments"
            :key="i"
          >
            <v-expansion-panel-header color="teal lighten-3" class="pa-6">
              <div class="headline grey--text text--darken-4 text-capitalize">
                ~{{ comment.from }}
              </div>
              <div class="grey--text text--darken-2">
                {{ newTime(comment.time) }}
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="body-2 pa-4">{{
              comment.content
            }}</v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="11">
        <v-card class="pa-8" color="#e8eddf" elevation="10">
          <v-form @submit.prevent="submit">
            <v-textarea
              v-model="comment"
              name="comment"
              color="#242423"
              outlined
              label="Your Comment"
              auto-grow
              clearable
              append-icon="mdi-comment"
            ></v-textarea>
            <p v-if="feedback" class="red--text text-center text--darken-4">
              * {{ feedback }}
            </p>
            <v-btn @click.prevent="submit" color="success" elevation="5" large
              >Submit</v-btn
            >
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import db from '../firebase'
import firebase from 'firebase'
import moment from 'moment'

export default {
  name: 'Profile',

  data () {
    return {
      comments: [],
      profile: null,
      comment: null,
      feedback: null,
      from: null
    }
  },

  created () {
    db.collection('comments')
      .where('to', '==', this.$route.params.id)
      .onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          if (change.type === 'added') {
            this.comments.unshift(change.doc.data())
          }
        })
      })

    const ref = db.collection('users')

    ref
      .where('user_id', '==', firebase.auth().currentUser.uid)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          this.from = doc.data().alias
        })
      })

    ref
      .doc(this.$route.params.id)
      .get()
      .then(doc => {
        this.profile = doc.data()
      })
  },

  methods: {
    submit () {
      if (this.comment) {
        db.collection('comments')
          .add({
            content: this.comment,
            from: this.from,
            to: this.$route.params.id,
            time: Date.now()
          })
          .then(() => {
            this.feedback = null
            this.comment = null
          })
      } else {
        this.feedback = 'You need to add some comment to Submit'
      }
    },

    newTime (val) {
      return moment(val).format('MMMM Do YYYY, h:mm:ss a')
    }
  }
}
</script>

<style></style>
